import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Saute en haut de chaque page lors d'un changement de route,
// sans aucune animation (force behavior: instant, ignore le smooth CSS global).
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);

    return null;
}
